import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import { NewsletterComponent } from './newsletter.component';
import { TextboxModule, DropdownlistModule,TextareaModule } from 'controls';


@NgModule({
  declarations: [NewsletterComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextboxModule,
  ],
  exports:[NewsletterComponent]
})
export class NewsletterModule { }
